// extracted by mini-css-extract-plugin
export default {"data_number":"dataNumber_data_number__sn4NN","data_number_earliest":"dataNumber_data_number_earliest__mvbhg"};